import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';

import { Link as RouterLink } from 'react-router-dom';
import Networker from '../Utils/Networker';
import MadeWithLove from '../Components/MadeWithLove';

import withStyle from '../style';
import Loader from '../Components/Loader';

export default function ResetPassword({ match }) {
  const [resetDone, setResetDone] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [email, setEmail] = React.useState('');
  const token = match.params.token;

  const classes = withStyle();

  const setField = (e) => {
    if (e.target.id === 'password') {
      setPassword(e.target.value);
    } else if (e.target.id === 'email') {
      setEmail(e.target.value);
    }
  };

  const onResetClick = (e) => {
    e.preventDefault();

    if (!email || !password) {
      window.alert('Please enter your email and new password.');
      return;
    }

    setLoading(true);
    Networker.resetPassword({ email, password, token })
      .then(() => {
        setResetDone(true);
        setLoading(false);
      })
      .catch((err) => {
        setResetDone(false);
        setLoading(false);

        Networker.sendError({
          message: 'reset password error',
          namespace: 'dashboard.resetpassword',
          data: err
        });

        window.alert('Reset failed. Please request a new link and try again.');
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <center style={{ margin: '5vh' }}>
        <img src="/logo.png" width="100%" alt="Adrich Dashboard Logo" />
      </center>

      <div className={classes.paper}>
        <Typography component="h1" variant="h4">
          Reset Password
        </Typography>

        {resetDone ? (
          <>
            <Typography component="h2" variant="h6" style={{ marginTop: 16 }}>
              Your password has been updated.
            </Typography>

            <Typography variant="body2" style={{ marginTop: 12 }}>
              Open the Adrich 3.0 app and sign in with your new password:
            </Typography>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              href="https://apps.apple.com/us/app/adrich-3-0/id6749334986"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.submit}
              style={{ marginTop: 16 }}
            >
              Open on iOS (App Store)
            </Button>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              href="https://play.google.com/store/apps/details?id=io.adrich"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.submit}
              style={{ marginTop: 16 }}
            >
              Open on Android (Google Play)
            </Button>

            <Button
              fullWidth
              variant="outlined"
              component={RouterLink}
              to="/login"
              className={classes.submit}
              style={{ marginTop: 16 }}
            >
              Continue to Dashboard Login
            </Button>
          </>
        ) : (
          <form className={classes.form} noValidate onSubmit={onResetClick}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Confirm Your Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={setField}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Enter Your New Password"
              type="password"
              id="password"
              autoComplete="new-password"
              onChange={setField}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={loading || !email || !password}
              style={{ marginTop: 8 }}
            >
              Reset My Password
            </Button>

            <Grid container style={{ marginTop: 8 }}>
              <Grid item xs>
                <Link component={RouterLink} to="/recover" variant="body2">
                  Need a new reset link?
                </Link>
              </Grid>
              <Grid item>
                <Link component={RouterLink} to="/register" variant="body2">
                  Don't have an account? Sign Up
                </Link>
              </Grid>
            </Grid>
          </form>
        )}
      </div>

      <Box mt={5}>
        <MadeWithLove />
      </Box>

      <Loader show={loading} />
    </Container>
  );
}